module.exports = "/_next/static/images/8f3c2228b1c795ecc2ac17f11f81ef9d-mother-and-daugther@2x.jpg.webp";